'use client';

/**
 * Product Gallery Component - Magento Style
 *
 * Matches production design:
 * - Main product image only (when mainImageOnly=true)
 * - Thumbnails and videos are rendered separately in the left column
 */
import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
interface ProductImage {
  id: number;
  url: string;
  altText: string | null;
  position: number;
  role: string | null;
}
interface ProductGalleryProps {
  images: ProductImage[];
  productName: string;
  mainImageOnly?: boolean;
  selectedImageIndex?: number;
}
export function ProductGallery(t0) {
  const $ = _c(7);
  const {
    images,
    productName,
    mainImageOnly: t1,
    selectedImageIndex
  } = t0;
  const mainImageOnly = t1 === undefined ? false : t1;
  let displayImage;
  if (selectedImageIndex !== undefined && images[selectedImageIndex]) {
    displayImage = images[selectedImageIndex];
  } else {
    const mainImageIdx = images.findIndex(_temp);
    displayImage = mainImageIdx >= 0 ? images[mainImageIdx] : images[0];
  }
  let t2;
  if ($[0] !== displayImage || $[1] !== productName) {
    t2 = displayImage ? <Image src={displayImage.url} alt={displayImage.altText || productName} fill={true} sizes="(max-width: 768px) 100vw, 50vw" className="object-contain" priority={true} /> : <div className="flex items-center justify-center h-full bg-gray-100 text-gray-400">No image available</div>;
    $[0] = displayImage;
    $[1] = productName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const imageElement = t2;
  if (mainImageOnly) {
    let t3;
    if ($[3] !== imageElement) {
      t3 = <div className="product-gallery-main relative">{imageElement}</div>;
      $[3] = imageElement;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== imageElement) {
    t3 = <div><div className="product-gallery-main relative">{imageElement}</div></div>;
    $[5] = imageElement;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(img) {
  return img.role === "main";
}